import { io } from "socket.io-client";

let socket = null;

// Flag to control whether socket should connect
const ENABLE_SOCKET = import.meta.env.VITE_ENABLE_SOCKET === "true";
if (ENABLE_SOCKET) {
  // Create a single, shared socket connection instance
  socket = io(import.meta.env.VITE_API_URL, {
    path: import.meta.env.VITE_SOCKET_PATH,
    timeout: import.meta.env.VITE_SOCKET_TIMEOUT,
    transports: ["websocket", "polling"],
  });

  // Optional: Add global listeners here for debugging or app-wide logic
  socket.on("connect", () => {
    console.log("Socket connected successfully With ID=> :", socket.id);
  });

  socket.on("disconnect", (reason) => {
    console.log("Socket disconnected:", reason);
  });

  socket.on("connect_error", (error) => {
    console.error("Socket connection error:", error.message);
  });
} else {
  console.log("Socket connection is disabled.");
}

// Export the initialized socket instance
export default socket;
